  // Download Assessment PDF (POST)
  // downloadAssessmentPDF: async ({ assessmentId, sessionID, documentType, language }) => {
  //   try {
  //     const apiClient = await createApiClient();
  //     const payload = {
  //       assessmentId,
  //       sessionID,
  //       documentType,
  //       language
  //     };
  //     const response = await apiClient.post('/Assessment/DownloadAssessmentPDF', payload, {
  //       responseType: 'blob',
  //       headers: {
  //         'Accept': '*/*',
  //         'Content-Type': 'application/json'
  //       }
  //     });
  //     if (response.status !== 200) {
  //       throw new Error(`Failed to download Assessment PDF: ${response.status}`);
  //     }
  //     // Create a blob from the PDF content
  //     const blob = new Blob([response.data], { type: 'application/pdf' });
  //     const url = window.URL.createObjectURL(blob);
  //     const link = document.createElement('a');
  //     link.href = url;
  //     link.download = `${assessmentId || 'Assessment'}.pdf`;
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);
  //     window.URL.revokeObjectURL(url);
  //     return response;
  //   } catch (error) {
  //     console.error('Error in downloadAssessmentPDF:', error);
  //     throw error;
  //   }
  // },
import axios from 'axios';
import { getIdToken } from './Authservice';

// Base URL for API endpoints - would be configured per environment
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL ;

// Extract URL parameters from current URL
const extractUrlParams = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const params = {};

  // Extract specific parameters we're interested in
  params.SessionId = searchParams.get('SessionId');
  // params.UserID = searchParams.get('UserID');
  // params.MemberID = searchParams.get('MemberID');
  params.PatientId = searchParams.get('PatientId');
  params.HRAId = searchParams.get('HRAId');
  
  return params;
};

//Create axios instance with common configuration
// const createApiClient = () => {
//   return axios.create({
//     baseURL: API_BASE_URL,
//     headers: {
//       'Content-Type': 'application/json',
//       //'accept': '*/*'
//       'Authorization': `${idToken}`
//     }
//   });
// };

const createApiClient = async () => {
  // Get the ID token for authentication
  const idToken = await getIdToken();
  
  return axios.create({
    baseURL: API_BASE_URL,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${idToken}` // Add the Bearer token to all requests
    }
  });
};



// Helper function to set common headers for API calls
const setCommonHeaders = async (customHeaders = {}) => {
  const idToken = await getIdToken();
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${idToken}`,
    ...customHeaders
  };
};

// Helper function to build query parameters for API calls
const buildQueryParams = (params) => {
  const queryParams = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value !== null && value !== undefined) {
      queryParams.append(key, value);
    }
  }
  return queryParams.toString();
};

// Assessment service methods
const assessmentService = {
  // Get decrypted parameters
  getDecryptParams: async () => {
    try {
      const { SessionId, PatientId, HRAId } = extractUrlParams();
      const queryParams = buildQueryParams({
        Sessionid: SessionId,
        PatientId,
        HRAId
      });
      const apiClient = await createApiClient();
      const response = await apiClient.get(`/Assessment/GetDecryptParam?${queryParams}`);
      
      if (response.status === 200 && response.data) {
        sessionStorage.setItem('assessmentSessionId', response.data.sessionid);
        sessionStorage.setItem('assessmentPatientId', response.data.patientId);
        sessionStorage.setItem('assessmentHRAId', response.data.hraId);
        sessionStorage.setItem('assessmentDecryptedParams', JSON.stringify(response.data));
      }
      return response;
    } catch (error) {
      console.error('Error in getDecryptParams:', error);
      throw error;
    }
  },

  // Load Assessment Master using decrypted sessionid
  loadAssessmentMaster: async () => {
    try {
      const sessionid = sessionStorage.getItem('assessmentSessionId');
      if (!sessionid) {
        throw new Error('SessionId not found in sessionStorage');
      }
      
      const apiClient = await createApiClient();
      const response = await apiClient.get(`/Assessment/LoadAssessmentMaster?Sessionid=${sessionid}`);
      
      if (response.status !== 200) {
        throw new Error(`Failed to load assessment master: ${response.status}`);
      }
      if (response.data && response.data.message === 'Session Expired.') {
        const sessionExpiredError = new Error('Session Expired.');
        sessionExpiredError.isSessionExpired = true;
        throw sessionExpiredError;
      }
      if (response.data) {
      sessionStorage.setItem('assessmentMasterData', JSON.stringify(response.data));
    }
      if (Array.isArray(response.data) && response.data.length > 0) {
          sessionStorage.setItem('masterHraId', response.data[0].hra_id);
        } 
        // If response is a single object
        else if (response.data.hra_id) {
          sessionStorage.setItem('masterHraId', response.data.hra_id);
        }
      
      return response;
    } catch (error) {
      console.error('Error in loadAssessmentMaster:', error);
      throw error;
    }
  },

  // Get archived assessment details
  getArchivedAssessment: async (selectedHraId) => {
    try {
      const sessionId = sessionStorage.getItem('assessmentSessionId');

      if (!sessionId || !selectedHraId) {
        throw new Error('Required session data or HRA ID is missing');
      }
      
      const queryParams = buildQueryParams({
        SessionId: sessionId,
        HraId: selectedHraId
      });
      
      const apiClient = await createApiClient();
      const response = await apiClient.get(`/Assessment/GetArchivedAssessment?${queryParams}`);
      
      if (response.status !== 200) {
        throw new Error(`Failed to fetch archived assessment: ${response.status}`);
      }

      // Store the archived assessment response in session storage
      if (response.data) {
        sessionStorage.setItem('archivedAssessmentData', JSON.stringify(response.data));
      }
      
      return response;
    } catch (error) {
      console.error('Error in getArchivedAssessment:', error);
      throw error;
    }
  },

  // Get Assessment Question Answer
  getAssessmentQuestionAnswer: async (obxId) => {
    try {
      const sessionId = sessionStorage.getItem('assessmentSessionId');

      if (!sessionId) {
        throw new Error('Session ID is missing');
      }
      // Allow obxId to be any value including 0, null, or undefined
      
      const queryParams = buildQueryParams({
        sessionid: sessionId,
        Obxid: obxId
      });
      
      const apiClient = await createApiClient();
      const response = await apiClient.get(`/Assessment/GetAssessmentQuestionAnswer?${queryParams}`);
      
      if (response.status !== 200) {
        throw new Error(`Failed to fetch assessment question answer: ${response.status}`);
      }
      if (response.data) {
        sessionStorage.setItem('assessmentQuestionAnswer', JSON.stringify(response.data));
      }

      return response;
    } catch (error) {
      console.error('Error in getAssessmentQuestionAnswer:', error);
      throw error;
    }
  },
  downloadObservationPDF: async (obxId) => {
    try {
      const sessionId = sessionStorage.getItem('assessmentSessionId');

      if (!sessionId) {
        throw new Error('SessionId is missing');
      }

      // Allow obxId=0 for In Progress
      const queryParams = buildQueryParams({
        sessionid: sessionId,
        Obxid: obxId
      });

      const apiClient = await createApiClient();
      // First API call to get fileGuid and fileName
      const response = await apiClient.get(`/Assessment/DownloadObservationPDF?${queryParams}`);

      if (response.status !== 200) {
        throw new Error(`Failed to get PDF details: ${response.status}`);
      }

      // Get the fileGuid and fileName from the response
      if (!response.data || !response.data.fileGuid || !response.data.fileName) {
        throw new Error('File details not found in response');
      }

      // Second API call to download the PDF using fileGuid and fileName (POST instead of GET)
      const downloadPayload = {
        fileGuid: response.data.fileGuid,
        filename: response.data.fileName
      };

      const downloadResponse = await apiClient.post('/Assessment/AssessmentDownload', downloadPayload, {
        responseType: 'blob',
        headers: {
          'Accept': 'application/pdf'
        }
      });

      if (downloadResponse.status !== 200) {
        throw new Error(`Failed to download PDF: ${downloadResponse.status}`);
      }

      // Create a blob from the PDF content
      const blob = new Blob([downloadResponse.data], { type: 'application/pdf' });

      // Create a URL for the blob
      const url = window.URL.createObjectURL(blob);

      // Ensure the filename ends with .pdf
      let fileName = response.data.fileName;
      if (!fileName.toLowerCase().endsWith('.pdf')) {
        fileName = fileName + '.pdf';
      }
      // Create a link element to trigger the download
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      // Append link to body, click it, and remove it
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      // Clean up the URL
      window.URL.revokeObjectURL(url);

      return downloadResponse;
    } catch (error) {
      console.error('Error in downloadObservationPDF:', error);
      throw error;
    }
  },
  //Testing
  downloadAssessmentPDF: async ({ assessmentId, sessionID, documentType, language }) => {
    try {
      const apiClient = await createApiClient();
      const payload = {
        assessmentId,
        sessionID,
        documentType,
        language
      };
      // First API call to get fileGuid and fileName
      const response = await apiClient.post('/Assessment/DownloadAssessmentPDF', payload, {
        headers: {
          'Accept': '*/*',
          'Content-Type': 'application/json'
        }
      });
      if (response.status !== 200) {
        throw new Error(`Failed to get Assessment PDF details: ${response.status}`);
      }
      if (!response.data || !response.data.fileGuid || !response.data.fileName) {
        throw new Error('File details not found in response');
      }

      // Second API call to download the PDF using fileGuid and fileName
      const downloadPayload = {
        fileGuid: response.data.fileGuid,
        filename: response.data.fileName
      };
      const downloadResponse = await apiClient.post('/Assessment/AssessmentDownload', downloadPayload, {
        responseType: 'blob',
        headers: {
          'Accept': 'application/pdf'
        }
      });
      if (downloadResponse.status !== 200) {
        throw new Error(`Failed to download Assessment PDF: ${downloadResponse.status}`);
      }
      // Create a blob from the PDF content
      const blob = new Blob([downloadResponse.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      // Ensure the filename ends with .pdf
      let fileName = response.data.fileName;
      if (!fileName.toLowerCase().endsWith('.pdf')) {
        fileName = fileName + '.pdf';
      }
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      return downloadResponse;
    } catch (error) {
      console.error('Error in downloadAssessmentPDF:', error);
      throw error;
    }
  }
  
};

export default assessmentService;
